module.exports = __webpack_public_path__ + "img/icon_graph_stock.24819244.png";